import { Box, Typography, Paper, Stack } from '@mui/material';
import { ICONS } from './icons';

function FeatureSection({ icon, step, title, description, tone = 'light' }) {
  const Icon = ICONS[icon];
  const dark = tone === 'dark';
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2.5,
        height: '100%',
        bgcolor: dark ? 'transparent' : 'background.paper',
        borderColor: dark ? 'rgba(255,255,255,0.16)' : 'divider',
        color: dark ? 'white' : 'text.primary',
      }}
    >
      <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center', mb: 2 }}>
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: 2,
            display: 'grid',
            placeItems: 'center',
            background: dark ? 'rgba(255,255,255,0.12)' : 'linear-gradient(135deg, rgba(78,40,181,0.1) 0%, rgba(124,92,214,0.14) 100%)',
            flexShrink: 0,
          }}
        >
          {Icon && <Icon sx={{ color: dark ? 'white' : 'primary.main' }} />}
        </Box>
        {step && (
          <Typography variant="caption" sx={{ fontWeight: 700, color: dark ? 'rgba(255,255,255,0.6)' : 'text.secondary' }}>
            STEP {step}
          </Typography>
        )}
      </Stack>
      <Typography variant="h6" fontWeight={700} gutterBottom>
        {title}
      </Typography>
      <Typography color={dark ? 'rgba(255,255,255,0.75)' : 'text.secondary'}>{description}</Typography>
    </Paper>
  );
}

export default FeatureSection;
